import * as React from 'react'
import { PrimeButton } from 'DVWebNodeUI'

interface SignUpCTA {
  text: string,
  href: string
}

export const SignUpCTA = ({text, href}: SignUpCTA) => (
  <div className="pv-nav-sign-up-button">
    <PrimeButton href={href} className="CTA-button">
      {text}
    </PrimeButton>
  </div>
)
